import dayjs from 'dayjs';
import { formateNumber, getCurrentTimeZone } from 'shared/helpers';

export class FinanceApiConverter {
  convertFinanceHistory = data => {
    let arrTransfers = [];
    arrTransfers = data.transfers.map(el => ({
      id: el?.id,
      initiator: el?.initiator_user,
      fromUser: el?.from_user,
      toUser: el?.to_user,
      date: getCurrentTimeZone(dayjs(el.created_at)).format('DD/MM/YY'),
      transitionType: el?.operation === 0 ? 'deposit' : 'withdrawal',
      amount: formateNumber(el.amount),
      balanceBefore: formateNumber(el?.additional_data.balance_before),
      balanceAfter: formateNumber(el?.additional_data.balance_after),
      // fromUserId: el?.from_user_id,
      // toUserId: el?.to_user_id,
      // currency: el?.currency,
    }));

    return {
      transfers: arrTransfers,
      details: {
        totalDeposit: data.details.total_deposit,
        totalWithdraw: data.details.total_withdraw,
        deltaBalance: data.details.delta_balance,
        totalCount: /* formateNumber */ data.details.total_count,
        commissionBalance: data.details.commission_balance,
      },
    };
  };

  convertFlatPages = data => {
    return data.map(el => {
      return {
        priority: el.priority,
        createdAt: el.created_at,
        text: el.text,
        id: el.id,
        name: el.name,
        isActive: el.is_active,
        updatedAt: el.updated_at,
        idName: el.id_name,
        lang: el.lang,
      };
    });
  };

  convertSettings = data => {
    return data;
  };
}
